import React from "react";
import { useDialog } from "../../../context";
import {
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import StyledButton from "../StyledButton";
import StyledDialog from "./StyledDialog";

const ConfirmDialog = () => {
    const { confirm, hideConfirm } = useDialog();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const handleClose = () => {
        hideConfirm();
    };
    const handleClosed = () => {
        if (!!confirm.close) {
            confirm.close();
        }
        hideConfirm();
    };
    return (
        <React.Fragment>
            <StyledDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                fullScreen={fullScreen}
                open={!!confirm}
            >
                <DialogTitle x={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Confirm
                </DialogTitle>
                <DialogContent sx={{ width: 400 }} dividers>
                    <Typography variant="h5" sx={{ textAlign: "center" }} gutterBottom>
                        {confirm?.message}
                    </Typography>
                    <Typography variant="h6" sx={{ textAlign: "center",color:'#E62E05' }} gutterBottom>
                        {confirm?.note}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <StyledButton variant="outlined" onClick={handleClose}>
                        No
                    </StyledButton>
                    <StyledButton variant="contained" onClick={handleClosed}>
                        Yes
                    </StyledButton>
                </DialogActions>
            </StyledDialog>
        </React.Fragment>
    );
};

export default ConfirmDialog;
